import fetcher from "../src/fetcher";
import "../src/registrations";
import { showMessage } from "../src/utils/alert";

document.addEventListener("DOMContentLoaded", () => {
  const userCellNo = document.querySelector<HTMLInputElement>("#cell-no");
  const email = document.querySelector<HTMLInputElement>("#email");
  const parentEmail = document.querySelector<HTMLInputElement>("#parent-email");

  const cellNoInvalidFeedback = document.getElementById(
    "cell-no-invalid-feedback",
  );
  const emailInvalidFeedback = document.getElementById(
    "email-invalid-feedback",
  );
  const parentEmailInvalidFeedback = document.getElementById(
    "parent-email-invalid-feedback",
  );

  userCellNo?.addEventListener("input", async () => {
    if (!userCellNo.minLength) return;

    if (/[^0-9]/.test(userCellNo.value)) {
      const message = "Phone Number should only contain digits";
      userCellNo.title = message;
      if (cellNoInvalidFeedback) cellNoInvalidFeedback.innerHTML = message;
      return;
    }

    try {
      if (userCellNo.value.length >= userCellNo.minLength) {
        const res = await fetcher(
          `/users/is-user-exists?user[cell_no]=${userCellNo.value}`,
        );
        const resJson = await res.json();

        if (resJson.is_user_exists) {
          userCellNo.setCustomValidity("Cell No is already taken");

          if (cellNoInvalidFeedback) {
            cellNoInvalidFeedback.innerHTML = `
              <a
                class='fs-12 text-danger'
                data-bs-toggle="offcanvas"
                data-bs-target="#landing-login"
                aria-controls="landing-login"
              >
                This phone number is already linked with an existing account.
                ${
                  cellNoInvalidFeedback.dataset.edit
                    ? ""
                    : "Please <span class='text-primary'>Log in</span> to continue."
                }
              </a>
            `;
          }
        } else {
          userCellNo.setCustomValidity("");

          if (cellNoInvalidFeedback) cellNoInvalidFeedback.innerHTML = ``;
        }
        checkElementValidity(userCellNo);
      } else {
        userCellNo.setCustomValidity("");

        const message = `
          Phone Number should be at least ${userCellNo.minLength} digits long,
          you have currently added ${userCellNo.value.length} digits.
        `;
        userCellNo.title = message;
        if (cellNoInvalidFeedback) cellNoInvalidFeedback.innerHTML = message;
      }
    } catch (e) {
      console.error(e);
    }
  });

  email?.addEventListener("blur", async (e) => {
    const res = await fetcher(
      `/users/is-user-exists?user[email]=${email.value}`,
    );
    const resJson = await res.json();

    if (resJson.is_user_exists) {
      email.setCustomValidity("Email is already taken");

      if (emailInvalidFeedback) {
        emailInvalidFeedback.innerHTML = `
          <a
            class='fs-12 text-danger'
            ${
              email.dataset.iframe
                ? `
                  href="/?sign_in=true"
                  target="_top"
                `
                : `
                  data-bs-toggle="offcanvas"
                  data-bs-target="#landing-login"
                  aria-controls="landing-login"
                `
            }

          >
            This email is already linked with an existing account.
            Please
            <span class='text-decoration-underline text-primary'>Log in</span>
            to continue.
          </a>
        `;
      }
    } else {
      email.setCustomValidity("");
      if (emailInvalidFeedback) {
        emailInvalidFeedback.innerHTML = "Please input a valid email address";
      }
    }
    checkElementValidity(email);
  });

  parentEmail?.addEventListener("blur", async (e) => {
    if (parentEmail.value && email?.value && parentEmail.value === email.value) {
      parentEmail.setCustomValidity("Parent email cannot be the same as your email address");

      if (parentEmailInvalidFeedback) {
        parentEmailInvalidFeedback.innerHTML = "Parent email must be different from your email";
      }
    } else {
      parentEmail.setCustomValidity("");

      if (parentEmailInvalidFeedback) {
        parentEmailInvalidFeedback.innerHTML = "";
      }
    }

    checkElementValidity(parentEmail);
  });

  const referrerSource =
    document.querySelector<HTMLSelectElement>("#referrer-source");
  const otherSource = document.querySelector<HTMLInputElement>("#other-source");
  const timezone = document.querySelector<HTMLSelectElement>("#timezone");

  referrerSource?.addEventListener("input", () => {
    if (referrerSource.value === "Other") {
      timezone?.parentElement?.classList.remove("col-md-6");
      timezone?.parentElement?.classList.add("col-12");
      otherSource?.parentElement?.classList.remove("d-none");
      otherSource?.parentElement?.classList.add("d-block");
      otherSource?.setAttribute("required", "required");
    } else {
      timezone?.parentElement?.classList.add("col-md-6");
      timezone?.parentElement?.classList.remove("col-12");
      otherSource?.parentElement?.classList.remove("d-block");
      otherSource?.parentElement?.classList.add("d-none");
      otherSource?.removeAttribute("required");
    }
  });
  referrerSource?.dispatchEvent(new Event("input"));

  document
    .querySelectorAll<HTMLInputElement>(
      "input:not(.no-state-update), select:not(.no-state-update)",
    )
    .forEach((element) => {
      element.addEventListener("input", () => {
        checkElementValidity(element);
        element.reportValidity();
      });
      element.addEventListener("show-validity", () =>
        checkElementValidity(element),
      );

      if (element.value && element.getAttribute("type") !== "checkbox") {
        if (["email", "cell-no", "parent-email"].includes(element.id))
          element.dispatchEvent(new Event("blur"));
        checkElementValidity(element);
      }
    });

  document.addEventListener("timezone-updated", async () => {
    try {
      const res = await fetcher("/users/timezone");
      const resJson: { timezone: string } = await res.json();

      if (timezone) timezone.value = resJson.timezone;
    } catch (e) {
      console.error(e);
      showMessage("Unable to fetch browser timezone");
    }
  });
});

// Add relevant validity class on element
const checkElementValidity = (element: HTMLInputElement) => {
  if (element.type === "radio") return;

  if (element.validity.valid) {
    element.classList.add("is-valid");
    element.classList.remove("is-invalid");
  } else {
    element.classList.add("is-invalid");
    element.classList.remove("is-valid");
  }
};
